<!--
    @description :
    @api-property :
    @api-event :
    @api-method :

    @author :
    @dateTime :
    @lastEditDateTime :
    @lastEditors :
-->
<template>
  <div style="height: 100%">
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        padding: 0 200px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
      "
      :style="{ backgroundImage: 'url(' + require('@/assets/bg.jpg') + ')' }"
    >
      <div
        class="classification-course"
        v-for="(item, index) in classType"
        :key="index"
        @click="lookDetails(item)"
        style="cursor: pointer"
      >
        {{ item.name }}
      </div>
      <!--      <div class="classification-course">专家讲座</div>-->
      <!--      <div class="classification-course">适宜技术</div>-->
      <!--      <div class="classification-course">3min快学</div>-->
    </div>
  </div>
</template>
<script>
import { trainingClassService } from "@/api";
export default {
  //组件名字
  name: "ChineseMedicine",
  //组件参数
  props: {},
  //组件状态数据值
  data() {
    return {
      classId: "",
      classType: [],
    };
  },
  //计算属性
  computed: {},
  async created() {
    await this.getTrainingClass();
    await this.getClassType();
  },
  //方法
  methods: {
    async getTrainingClass() {
      let data = await trainingClassService.officialWebsiteTrainingClassId();
      this.classId = data.data[0];
    },
    async getClassType() {
      let data = await trainingClassService.listCourseTypeByClass({
        class_id: this.classId,
      });
      if (data.data && data.data.list && data.data.list.length > 0) {
        for (let i in data.data.list) {
          if (i < 4) {
            this.classType.push(data.data.list[i]);
          }
        }
      }

      // this.classType = data.data.list;
    },
    lookDetails(item) {
      this.$router.push({
        path: "/chineseMedicineDetails",
        query: {
          id: item.id,
          name: item.name,
        },
      });
    },
  },
  //监听
  watch: {},

  //局部注册的组件
  components: {},
};
</script>
<style scoped lang="less">
.classification-course {
  height: 200px;
  width: 150px;
  background-color: #35a8a4;
  color: #fff;
  border-radius: 10px;
  text-align: center;
  line-height: 200px;
  font-size: 30px;
  font-weight: bold;
}
</style>
